export default __webpack_public_path__ + "static/md9-5e9afebb0a23ee40af409b4e6f6426f9.png";